import React from 'react';
import TableCellWithTooltip from './TableCellWithTooltip';
import { cashRegisterTableColumn } from '../../../../enum/TableColumn';

interface TableHeaderProps {
  column: string;
  toggleSort: (key: string) => void;
  getSort: () => string;
  columnKey: string;
}

const TableHeader: React.FC<TableHeaderProps> = ({ column, toggleSort, getSort, columnKey }) => {
  return (
    <div className={`table_header ${column === cashRegisterTableColumn.ACTIONS ? 'table_header_image' : ''}`}>
      <div className="table_row">
        <div key={column} className="table_cell">
          <div className="header_cell_content">
            <TableCellWithTooltip value={column} headerCell={true} className="header_title" />
            <img className="sort_icon" src={getSort()} alt="Sort" onClick={() => toggleSort(columnKey)} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default TableHeader;
